import axios from "axios";

const axiosBaseURL = axios.create({
  
  baseURL: process.env.REACT_APP_INTERNAL_URL,

  
});

export default axiosBaseURL;

export const axiosBaseURLExternal = axios.create({
  baseURL: process.env.REACT_APP_EXTERNAL_URL,
  headers: {
    "Content-Type": "multipart/form-data",
  },
});
